import { useState, useCallback } from 'react';
import { APPLICATION_CONFIG } from '../config';

interface UsePaginationReturn {
  maxItems: number;
  showMore: () => void;
}

/**
 * Custom Hook for pagination logic
 * Manages the number of displayed items
 */
export const usePagination = (
  pageSize: number = APPLICATION_CONFIG.DEFAULT_PAGE_SIZE,
): UsePaginationReturn => {
  const [maxItems, setMaxItems] = useState<number>(pageSize);

  const showMore = useCallback(() => {
    setMaxItems((prev) => prev + pageSize);
  }, [pageSize]);

  return {
    maxItems,
    showMore,
  };
};
